import { render, staticRenderFns } from "./vacancyContactPerson.vue?vue&type=template&id=596543da&"
import script from "./vacancyContactPerson.vue?vue&type=script&lang=js&"
export * from "./vacancyContactPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports